@if (!!loading) {
<mutara-alert class='mutara-root' 
icon="password" label="Verifying credentials" statusType="info" description="Please wait a moment while we verify the password change request..."></mutara-alert>
} @else {
    
<mutara-alert class='mutara-root' 
[icon]="successful ? 'check' :'error'" label="Verification Results" [statusType]="successful ? 'success' : 'invalid'" [description]="message" [secondaryText]="alertText"></mutara-alert>
}